import AutoScrollCard from "../../../components/AutoScrollCard/AutoScrollCard";
import "./AboutUs.scss";

const AboutUs = () => {
  const data = [
    {
      image: "./assets/images/choose1.png",
      title: "Advanced Security",
      text: "Your data security is our top priority. Our cloud ERP is fortified with advanced security layers across all modules, delivering a safe and reliable environment for your operations. With broad platform compatibility, data migration becomes smooth, secure, and stress-free.",
    },
    {
      image: "./assets/images/Accessible.png",
      title: "Anywhere Access",
      text: "Designed for flexibility, our ERP enables centralized access to cross-departmental data from anywhere. Whether working remotely or traveling, you can securely access insights and drive decisions without interruption.",
    },
    {
      image: "./assets/images/fixiblechoose.png",
      title: "Dynamic Reporting",
      text: "Accurate reporting is key to effective forecasting. Our cloud ERP enables you to create customized, insightful reports effortlessly, giving you the flexibility to analyze data and make informed decisions with confidence.",
    },
    {
      image: "./assets/images/endtoend.png",
      title: "Fully Integrated Solution",
      text: " VENSAP is a complete business management solution that unifies and streamlines your entire workflow. With seamless integration across all processes, the ERP platform delivers total control and operational clarity.",
    },
  ];
  return (
    <>
      <h1 className="product-title mx-4">About Us</h1>

      <section className="about-hero">
        <div className="about-container">
          {/* Left Image */}
          <div className="about-image">
            <img
              src="./assets/images/aboutus.png"
              alt="About VENSAP"
              className="img-fluid"
            />
          </div>

          {/* Right Content */}
          <div className="about-content">
            <h2>
              VENSAP – Transform Your Business for the Digital Era. End-to-End
              Cloud ERP Solutions
            </h2>

            <p>
              Transform the way you manage your organization with a powerful,
              unified software suite designed to streamline every aspect of your
              business operations. From finance and procurement to inventory,
              sales, and HR — everything is seamlessly integrated into a single
              platform.
              <br></br>Switching to Cloud ERP software has become the preferred
              choice for global leaders looking to stay ahead of the
              competition. With real-time data access, enhanced collaboration,
              improved efficiency, and scalable solutions, Cloud ERP empowers
              businesses to make smarter decisions and drive sustainable growth
            </p>
            <hr></hr>
            <p className="fw-bold">
              Move smarter || Operate faster || Grow stronger
            </p>
          </div>
        </div>

        <h1 className="d-flex justify-content-center m-2 p-2">
          How is VENSAP Different from Others?
        </h1>
        <AutoScrollCard items={data} interval={4000} />
        <div className="vm-section">
          <div className="vm-row">
            <div className="vm-image">
              <img src="./assets/images/vision.png" alt="Vision" />
            </div>

            {/* Vision */}
            <div className="vm-text">
              <h2>Vision</h2>
              <ul className="vm-list">
                <li>
                  To become the leading cloud ERP platform that intelligently
                  scales with business growth.
                </li>
                <li>
                  To eliminate heavy customization and significantly reduce
                  large upfront investments.
                </li>
                <li>
                  To deliver an affordable, accessible, and highly scalable ERP
                  solution tailored for small and mid-sized businesses.
                </li>
                <li>
                  To build a powerful, automation-driven platform that
                  simplifies repetitive processes and streamlines operational
                  tasks.
                </li>
                <li>
                  To enable seamless and sustainable digital transformation
                  across all business functions.
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* Mission */}
        <div className="vm-section">
          <div className="vm-row reverse">
            <div className="vm-image">
              <img src="./assets/images/mission.png" alt="Mission" />
            </div>

            <div className="vm-text">
              <h2>Mission</h2>
              <ul className="vm-list">
                <li>
                  To make work simpler, smarter, and more efficient for business
                  professionals.
                </li>
                <li>
                  To provide a fully integrated, ready-to-use cloud ERP platform
                  that streamlines operations across all departments.
                </li>
                <li>
                  To deliver flexible, scalable, and cost-effective business
                  solutions that grow with organizations.
                </li>
                <li>
                  To support businesses in achieving operational excellence
                  through process optimization and automation.
                </li>
                <li>
                 To empower organizations with intelligent tools that enhance productivity and enable data-driven decision-making.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;
